var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisclosureScreener = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 1.922a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm-.007 10.14c.281 0 .503.083.666.248a.85.85 0 0 1 .244.622c0 .242-.08.444-.238.607-.158.163-.382.244-.672.244-.29 0-.513-.081-.669-.244a.842.842 0 0 1-.234-.607c0-.259.081-.469.244-.629.162-.16.382-.24.66-.24ZM9 4.922h2v3l-.25 4h-1.5l-.25-4v-3Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisclosureScreener);
export default ForwardRef;